<template>
  <div
    class="flex items-center"
    :class="[{ 'bg-[#FFFFFF99] px-2 rounded-md w-fit': hasBackground }, colorClass ]"
  >
    <icon-dollar-sign-circle class="text-[20px] me-1 !mb-0" />
    <p class="text-mobile-heading-6 md:text-heading-6">
      {{ t(textKey) }}
    </p>
  </div>
</template>

<script setup>
const { t } = useI18n();
defineProps({
  hasBackground: { type: Boolean, default: false },
  textKey: { type: String, default: "payment.reserveNowPayLater" },
  colorClass: { type: String, default: "text-gray-1 my-1 py-1" },
});
</script>
